"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.tab.instructions': '说明',
    'trainer.tab.upload': '上传数据',
    'trainer.tab.config': '配置训练',
    'trainer.tab.training': '训练进度',
    'trainer.tab.results': '结果',
};
